import FadeAndRemove from '../../../core/utils/fade-and-remove'
import QuantityComponent from './quantity-component'

const BundleCart = () => {
  const CartService = Shopify.cartService

  const initCartItems = (items) => {
    items.forEach(item => {
      const isBundle = item.hasAttribute('data-bundle-locked')
      const passedItem = isBundle
        ? item
        : item.querySelector('[mx-line-item]')
      
      isBundle ?
        handleBundleItem(passedItem) :
        handleSingleItem(passedItem)
    })
  }
  
  const handleBundleItem = (item) => {
    const bundleLock = item.querySelector('[mx-lock-bundle] button')
    const bundleItems = Array.from(item.querySelectorAll('[mx-line-item]'))

    bundleLock.addEventListener('click', bundleLockChange)

    bundleItems.forEach(item => {
      handleSingleItem(item)
    })
  }

  const handleSingleItem = (item) => {
    initQuantityComponent(item)
    const removeButton = item.querySelector('[mx-item-remove]')
    removeButton.addEventListener('click', removeLineItem)
  }

  const updateLineItemData = (item) => {
    const cartItems = CartService.cart.items
    const itemsPerCase = parseInt(item.dataset.itemsPerCase) || 1
    let thisItem = getItemByUid( item )
    let key = thisItem.key
    // let key = item.getAttribute('data-cart-item-key')
    // update to get key by uid

    // key = getKeyByUid( item , key )
    // const thisItem = cartItems.find(item => item.key === key)
    const price = thisItem.final_line_price
    const pieces = thisItem.quantity
    const cases = pieces / itemsPerCase

    const labelBase = itemsPerCase > 1 ? 'Case' : 'Piece'
    const unit = itemsPerCase > 1 ? cases : pieces
    const labelSuffix = unit > 1 ? 's' : ''
    const label = labelBase + labelSuffix
    const piecesText = `(${pieces.toLocaleString('en-US')} pieces total)`

    const elements = {
      price: item.querySelector('[mx-item-price]'),
      label: item.querySelector('[mx-item-label]'),
      pieces: item.querySelector('[mx-item-pieces]'),
      childLabel: item.querySelector('[mx-child-label]'),
      childPieces: item.querySelector('[mx-child-pieces]'),
      inputCase: item.querySelector('[data-count-case]'),
    }

    const isCase = itemsPerCase > 1
    const isChild = item.hasAttribute('mx-bundle-child')

    if ( isCase ) {
      elements.label.innerText = label
      elements.pieces.innerText = piecesText
      elements.price.innerText = Shopify.formatMoney(price)
    }

    if ( !isCase ) {
      elements.label.innerText = label
      elements.price.innerText = Shopify.formatMoney(price)
    }

    if ( isChild ) {
      elements.childLabel.innerText = label

      if ( isCase ) {
        elements.childPieces.innerText = `${unit} ${label} ${piecesText}`
        elements.inputCase.value = unit
      }

      if ( !isCase ) {
        elements.childPieces.innerText = unit
        elements.inputCase.value = unit
      }
    }
  }

  const handleQuantityChange = (event) => {
    const { target: item, value } = event.detail
    let itemByUid = getItemByUid( item )
    let key = itemByUid.key
    // let key = item.getAttribute('data-cart-item-key')
    // // update to get key by uid
    // key = getKeyByUid( item , key )

    const wrapper = item.closest('[mx-cart-item]')
    const isParent = item.hasAttribute('mx-bundle-parent')
    const inBundle = wrapper.hasAttribute('data-bundle-locked')
    const isLocked = wrapper.dataset.bundleLocked === 'true'

    if ( value < 1 ) {
      removeLineItem(null, {
        item,
        key,
        wrapper,
        isParent
      })

      return
    }
    
    if ( isParent && isLocked ) {
      const children = Array.from(wrapper.querySelectorAll('[mx-bundle-child]'))
      const items = [...children, item]

      const updateData = children.reduce((acc, child) => {
        let itemByUid = getItemByUid( child )
        let childKey = itemByUid.key
        // let childKey = child.getAttribute('data-cart-item-key')
        // childKey = getKeyByUid( child , childKey )
        const itemsPerCase = parseInt(child.dataset.itemsPerCase) || 1

        let pieces = 0

        if ( itemsPerCase > 1 ) {
          const casesNeeded = Math.ceil(value / itemsPerCase)
          pieces = casesNeeded * itemsPerCase
        } else {
          pieces = value
        }
        
        acc[childKey] = pieces
        return acc
      }, {
        [key]: value
      })

      CartService
        .updateQuantity__update(updateData)
        .then(res => {
          if ( !res.success ) {
            throw new Error('Error updating parent and children quantities: BundleCart.handleQuantityChange')
          }

          items.forEach(item => {
            updateLineItemData(item)
          })

          updateBundleSubtotal(wrapper)
        })
        .catch(error => {
          console.error(error)
        })

      return
    }

    CartService
    .updateQuantity(key, value)
    .then(res => {
      if ( !res.success ) {
        throw new Error('Error updating quantity: BundleCart.handleQuantityChange')
      }

      updateLineItemData(item)
      if ( inBundle ) {
        updateBundleSubtotal(wrapper)
      }
    })
  }

  const removeLineItem = (event, data={}) => {
    const defaults = {
      item: null,
      key: null,
      wrapper: null,
      isParent: false
    }

    if ( event ) {
      event.preventDefault()
      defaults.item = event.target.closest('[data-cart-item]')
      let itemByUid = getItemByUid( defaults.item )
      defaults.key = itemByUid.key
      // defaults.key = defaults.item.getAttribute('data-cart-item-key')
      // defaults.key = getKeyByUid( defaults.item , defaults.key )

      defaults.wrapper = event.target.closest('[mx-cart-item]')
      defaults.isParent = defaults.item.hasAttribute('mx-bundle-parent')
    }

    const { item, key, wrapper, isParent } = {...defaults, ...data}

    if ( isParent ) {
      const itemKeys = []
      const children = Array.from(wrapper.querySelectorAll('[mx-bundle-child]'))

      itemKeys.push(key)
      children.forEach(child => {
        let itemByUid = getItemByUid( child )
        let key = itemByUid.key
        // let key = child.getAttribute('data-cart-item-key')
        // key = getKeyByUid( child , key )
        itemKeys.push(key )
        
      })

      CartService
        .removeItems(itemKeys)
        .then(() => FadeAndRemove(wrapper))

      return
    }

    if ( item.hasAttribute('mx-bundle-child') ) {
      callCartServiceRemoveItem(item, key, item)
        .then(res => {
          if ( !res ) {
            throw new Error('BundleCart.removeItem(childItem): Error on FadeAndRemove')
          }

          updateBundleParent(wrapper)
        })
        .catch(err => {
          console.error(err)
        })
      return
    }

    callCartServiceRemoveItem(item, key, wrapper)
  }

  const updateBundleSubtotal = (wrapper) => {
    const cartItems = CartService.cart.items
    const bundleItems = Array.from(wrapper.querySelectorAll('[mx-line-item]'))
    const subtotalText = wrapper.querySelector('[mx-bundle-subtotal]')

    const subtotal = bundleItems.reduce((acc, item) => {
      let cartItem = getItemByUid( item )
      let key = cartItem.key
      // let key = item.dataset.cartItemKey
      // key = getKeyByUid( item , key )
      // const cartItem = cartItems.find(item => item.key === key)
      const price = cartItem.final_line_price
      acc += price
      return acc
    }, 0)

    subtotalText.innerText = Shopify.formatMoney(subtotal)
  }

  const bundleLockChange = (e) => {
    e.preventDefault()
    const lock = e.currentTarget
    const lockMessage = lock.querySelector('[mx-lock-message]')
    const wrapper = lock.closest('[mx-cart-item]')
    const isLocked = wrapper.dataset.bundleLocked === 'true'

    lockMessage.innerText = isLocked
      ? 'Lock Quantities'
      : 'Edit Quantities'

    wrapper.setAttribute('data-bundle-locked', !isLocked)
  }

  const initQuantityComponent = (item) => {
    const quantityComponent = item.querySelector('[mx-quantity-component]')

    if ( !quantityComponent ) {
      console.warn('No quantity component found')
      return
    }

    QuantityComponent(quantityComponent)
  }

  const updateBundleParent = (wrapper) => {
    const hasChildren = wrapper.querySelector('[mx-bundle-child]') !== null

    if ( hasChildren ) {
      return updateBundleSubtotal(wrapper)
    }

    [
      wrapper.querySelector('[mx-lock-bundle]'),
      wrapper.querySelector('[mx-bundle-subtotal-wrapper]')
    ].forEach(el => el.remove())

    const bundleParent = wrapper.querySelector('[mx-bundle-parent]')

    bundleParent.removeAttribute('mx-bundle-parent')
    wrapper.removeAttribute('data-bundle-locked')
    bundleParent.setAttribute('mx-bundle-none', '')
  }

  const callCartServiceRemoveItem = (item, key, wrapper) => {
    return CartService
      .removeItem(key)
      .then(res => {
        if ( !res.success ) {
          throw new Error(`Error removing item: BundleCart.removeItem: ${item} | ${key}`)
        }

        return FadeAndRemove(wrapper)
      })
      .catch(err => {
        console.error(err)
      })
  }

  const getItemByUid = ( item   ) =>{
    const cartItems = CartService.cart.items
    const uid = item.getAttribute('data-cart-item-uid');
    const cartItem = CartService.getCartItemByUID(uid);
    console.log( cartItems, cartItem , uid );
    return cartItem
  }

  
  const init = () => {
    const cartItems = Array.from(document.querySelectorAll('[mx-cart-item]'))

    if ( typeof cartItems === 'undefined' || cartItems.length === 0 ) {
      console.warn('No cart items found')
    }

    document.addEventListener('BundleCartQuantityChanged', handleQuantityChange)

    initCartItems(cartItems)
  }

  init()
}

export default BundleCart;